import React, { useEffect, useState } from "react";
import Headline from "../../../atoms/Headline";
import { object } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import AuthorDetails from "../../../molecules/AuthorDetails";
import { getExcerpt } from "../../../utils/utils";
import { getAuthorObj } from "../../../helper/api";

import "./organism1.m.css";

const Organism1 = ({ story: { story }, publisherAttributes }) => {
  const storyObj = story;
  const authorObj = storyObj && storyObj.authors && storyObj.authors[0];
  const excerpt = getExcerpt(story);
  const headlineStyle = `${publisherAttributes.lang}-story-headline`;
  const excerptStyle = `${publisherAttributes.lang}-excerpt`;
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const organism1StyleName = `${publisherAttributes.lang}-base base`;
  const authorDisplayName = get(storyObj, ["metadata", "story-attributes", "author-display-name", "0"], null);
  const hideAuthorName = get(storyObj, ["metadata", "story-attributes", "hideauthor", 0], "no");
  const [author, setAuthor] = useState([]);

  const firstAuthor = async (authorId) => {
    if (authorId) {
      const data = await getAuthorObj(authorId);
      setAuthor((author) => [...author, data]);
    }
  };
  useEffect(() => {
    firstAuthor(authorObj.id);
  }, []);

  return (
    <div styleName={organism1StyleName} className="base organism1">
      <Link href={storyObj.url}>
        {storyObj.subheadline && (
          <Headline
            text={storyObj.subheadline}
            headlineType={4}
            headerLevel={4}
            className={`sub-headline ${publisherAttributes.lang === "en" ? "en-subheadline" : ""}`}
            styleName={subHeadlineStyle}
          />
        )}
        {storyObj.headline && (
          <Headline
            text={storyObj.headline}
            headlineType={26}
            headerLevel={2}
            headlineDesign="withbackground"
            styleName={headlineStyle}
          />
        )}
      </Link>
      {excerpt ? (
        <Link href={story.url}>
          <Headline
            text={excerpt}
            headerLevel={4}
            className={`story-excerpt ${publisherAttributes.lang === "en" ? "en-story-excerpt" : ""}`}
            styleName={excerptStyle}
            dangerouslySet={true}
          />
        </Link>
      ) : null}
      {hideAuthorName === "no" && (
        <AuthorDetails
          story={storyObj}
          authors={author}
          authorDisplayName={authorDisplayName}
          withAvatar={true}
          contributorType={2}
          authorDetailsType={"opinion-stories-author-details"}
          lang={publisherAttributes.lang}
          location={true}
        />
      )}
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(Organism1);
